/**
 * @generated SignedSource<<d1eb98a76742ae83e0619dd6463bd652>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type JobApplicationFilteredOutReasonEnum = "adminMode" | "applicantSource" | "availableOnly" | "bookmarked" | "bookmarkedByUserId" | "canWorkInTheUs" | "category" | "clientId" | "clientRawId" | "company" | "contractStatus" | "contractType" | "countries" | "evaluated" | "excludeHidden" | "experience" | "feedbackCountBelow" | "feedbackCountEqualOrAbove" | "firmId" | "fortune500" | "freelancerId" | "freelancerRawIdOrSlug" | "hasAnswers" | "hasProjectSubmission" | "hasVideoIntroduction" | "hiringManagerId" | "interviewStatus" | "jobApplicationStatus" | "jobId" | "jobsIds" | "locationTypeFilter" | "managedTeams" | "maxClientRate" | "maxUniversityRank" | "missingAnswers" | "missingProjectSubmission" | "missingVideoIntroduction" | "name" | "needsEvaluation" | "netFeedback" | "noCategory" | "order" | "positionTypes" | "rating" | "showNotNotified" | "showNotified" | "skills" | "skillsIds" | "sortBy" | "specializations" | "stage" | "status" | "statuses" | "tagsIds" | "timezoneFilter" | "university" | "user" | "verifiedOnly" | "withJobScreening" | "withoutJobScreening";
import { FragmentRefs } from "relay-runtime";
export type jobApplication_useFilteredOutReasons$data = {
  readonly filteredOutReasons: ReadonlyArray<JobApplicationFilteredOutReasonEnum> | null | undefined;
  readonly " $fragmentType": "jobApplication_useFilteredOutReasons";
};
export type jobApplication_useFilteredOutReasons$key = {
  readonly " $data"?: jobApplication_useFilteredOutReasons$data;
  readonly " $fragmentSpreads": FragmentRefs<"jobApplication_useFilteredOutReasons">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filters"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "jobApplication_useFilteredOutReasons",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "filters"
        }
      ],
      "kind": "ScalarField",
      "name": "filteredOutReasons",
      "storageKey": null
    }
  ],
  "type": "JobApplication",
  "abstractKey": null
};

(node as any).hash = "5a90f9c8e5c4211a83a23260bb6799cd";

export default node;
